import type {
  TPowderyMildewRiskIndexColor,
  TPowderyMildewRiskIndexLevelUppercased,
} from '@semios/app-platform-common'
import { powderyMildewRiskIndexLevelMap } from '@semios/app-platform-common'
import { BadgeCell } from 'App/Map/PanelDetails/SummaryGridTable/BadgeCell/BadgeCell'
import { translate } from 'i18n/i18n'

type TPowderyMildewRiskIndexContent = {
  title: string
  color: TPowderyMildewRiskIndexColor
  pathogenStatus: string
  biologicalsSARs: string
  sulfur: string
  demethylationInhibitors: string
  strobilurinsQuinolines: string
}

export const PowderyMildewRow = ({
  riskIndexLevel,
  includeWesternUSAContent,
}: {
  riskIndexLevel: TPowderyMildewRiskIndexLevelUppercased
  includeWesternUSAContent: boolean
}) => {
  const riskIndexContentMap: Record<TPowderyMildewRiskIndexLevelUppercased, TPowderyMildewRiskIndexContent> =
    {
      LOW: {
        title: translate.phrases.banyanApp('Low 0-30'),
        color: powderyMildewRiskIndexLevelMap.LOW.color,
        pathogenStatus: translate.phrases.banyanApp('Present'),
        biologicalsSARs: translate.phrases.banyanApp('7 to 14 day interval'),
        sulfur: translate.phrases.banyanApp('14 to 21 day interval'),
        demethylationInhibitors: translate.phrases.banyanApp('21 day interval or label interval'),
        strobilurinsQuinolines: translate.phrases.banyanApp('21 day interval or label interval'),
      },
      MODERATE: {
        title: translate.phrases.banyanApp('Moderate 40-50'),
        color: powderyMildewRiskIndexLevelMap.MODERATE.color,
        pathogenStatus: translate.phrases.banyanApp('Reproduces every 15 days'),
        biologicalsSARs: translate.phrases.banyanApp('7 day interval'),
        sulfur: translate.phrases.banyanApp('10 to 17 day interval'),
        demethylationInhibitors: translate.phrases.banyanApp('21 day interval'),
        strobilurinsQuinolines: translate.phrases.banyanApp('21 day interval'),
      },
      HIGH: {
        title: translate.phrases.banyanApp('High 60+'),
        color: powderyMildewRiskIndexLevelMap.HIGH.color,
        pathogenStatus: translate.phrases.banyanApp('Reproduces every 5 days'),
        biologicalsSARs: translate.phrases.banyanApp('Use not recommended'),
        sulfur: translate.phrases.banyanApp('7 day interval'),
        demethylationInhibitors: translate.phrases.banyanApp('10 to 14 day interval'),
        strobilurinsQuinolines: translate.phrases.banyanApp('14 day interval'),
      },
    }

  const riskIndexContent = riskIndexContentMap[riskIndexLevel]

  return (
    <div
      style={{
        padding: '15px 0',
      }}
    >
      <BadgeCell backgroundColor={riskIndexContent.color}>{riskIndexContent.title}</BadgeCell>
      <div
        style={{
          padding: '10px 0',
          fontSize: 'large',
        }}
      >
        <div>
          <strong>{`${translate.phrases.banyanApp('Pathogen Status')}:`}</strong>&nbsp;
          <span>{riskIndexContent.pathogenStatus}</span>
        </div>
        {includeWesternUSAContent && (
          <>
            <div>
              <strong>{`${translate.phrases.banyanApp('Biologicals & SARs')}:`}</strong>&nbsp;
              <span>{riskIndexContent.biologicalsSARs}</span>
            </div>
            <div>
              <strong>{`${translate.phrases.banyanApp('Sulfur')}:`}</strong>&nbsp;
              <span>{riskIndexContent.sulfur}</span>
            </div>
            <div>
              <strong>{`${translate.phrases.banyanApp('Demethylation-inhibitors(DMI)')}:`}</strong>&nbsp;
              <span>{riskIndexContent.demethylationInhibitors}</span>
            </div>
            <div>
              <strong>{`${translate.phrases.banyanApp('Strobilurins & Quinolines')}:`}</strong>&nbsp;
              <span>{riskIndexContent.strobilurinsQuinolines}</span>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
